import React, { Component } from "react";
import { Link } from "react-router-dom";

// CSS
import "../../styles/newDesign.scss";
import "../../styles/authForm.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { apiFetch, resolveTenant, registerStudent, listGovernorates, listStates } from "../../Helper/Api";

const properties = require("../../properties.json");

class SignUp extends Component {
  state = {
    tenant: null,
    notFound: false,

    fullName: "",
    email: "",
    password: "",
    studentPhone: "",
    parentPhone: "",
    governorateId: "",
    stateId: "",
    schoolStagesId: "",
    gender: "",

    governorates: [],
    states: [],
    schoolStages: [],

    buttonText: "Create account",
    submitting: false,
    msg: null,
  };

  componentDidMount() {
    document.title = properties.site_name + " - Sign up";

    resolveTenant()
      .then((tenant) => {
        this.setState({ tenant });
        return Promise.all([
          listGovernorates(),
          apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: tenant.teacherUserId } }),
        ]);
      })
      .then(([governorates, schoolStages]) => this.setState({ governorates, schoolStages }))
      .catch(() => this.setState({ notFound: true }));
  }

  onGovernorateChange = (e) => {
    const governorateId = e.target.value;
    this.setState({ governorateId, stateId: "", states: [] });
    if (!governorateId) return;
    listStates(governorateId)
      .then((states) => this.setState({ states }))
      .catch(() => {});
  };

  submit = (e) => {
    e.preventDefault();
    const { fullName, email, password, studentPhone, parentPhone, stateId, schoolStagesId, gender, tenant } =
      this.state;

    if (!fullName || !email || !password) {
      this.setState({ msg: { text: "Please fill in your name, email and password.", type: "warning" } });
      return;
    }
    if (password.length < 8) {
      this.setState({ msg: { text: "Password must be at least 8 characters.", type: "warning" } });
      return;
    }

    this.setState({ submitting: true, buttonText: "Creating account...", msg: null });

    registerStudent({
      fullName,
      email,
      password,
      mobile: studentPhone || null,
      fatherMobile: parentPhone || null,
      gender: gender ? Number(gender) : null,
      stateId: stateId ? Number(stateId) : null,
      schoolStagesId: schoolStagesId ? Number(schoolStagesId) : null,
      branchId: tenant.branchId,
    })
      .then(() => {
        this.setState({
          submitting: false,
          buttonText: "Create account",
          msg: { text: "Account created. You can sign in now.", type: "success" },
        });
        setTimeout(() => {
          window.location.href = "/sign-in";
        }, 1200);
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          buttonText: "Create account",
          msg: { text: error.message || "Could not create the account.", type: "warning" },
        });
      });
  };

  render() {
    const { tenant, notFound, governorates, states, schoolStages, buttonText, submitting, msg } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }
    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="auth-wrap">
            <div className="auth-box auth-box-wide">
              <div className="auth-tabs">
                <Link to="/sign-in" className="auth-tab">Sign in</Link>
                <span className="auth-tab active">Create account</span>
              </div>

              <div className="nd-eyebrow" style={{ marginBottom: 6 }}>Join us</div>
              <h1 style={{ fontSize: 26, marginBottom: 22 }}>Create a new account</h1>

              <form onSubmit={this.submit}>
                <div className="form-grid-2">
                  <div className="form-field">
                    <label htmlFor="full-name">Full name</label>
                    <input
                      type="text"
                      id="full-name"
                      value={this.state.fullName}
                      onChange={(e) => this.setState({ fullName: e.target.value })}
                    />
                  </div>
                  <div className="form-field">
                    <label htmlFor="e-mail">Email</label>
                    <input
                      type="email"
                      id="e-mail"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                    />
                  </div>
                  <div className="form-field">
                    <label htmlFor="city">Governorate</label>
                    <select id="city" value={this.state.governorateId} onChange={this.onGovernorateChange}>
                      <option value="">Select governorate</option>
                      {governorates.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label htmlFor="state">District / city</label>
                    <select
                      id="state"
                      value={this.state.stateId}
                      onChange={(e) => this.setState({ stateId: e.target.value })}
                    >
                      <option value="">Select district</option>
                      {states.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label htmlFor="stud-phone">Student phone</label>
                    <input
                      type="tel"
                      id="stud-phone"
                      value={this.state.studentPhone}
                      onChange={(e) => this.setState({ studentPhone: e.target.value })}
                    />
                  </div>
                  <div className="form-field">
                    <label htmlFor="parent-phone">Parent phone</label>
                    <input
                      type="tel"
                      id="parent-phone"
                      value={this.state.parentPhone}
                      onChange={(e) => this.setState({ parentPhone: e.target.value })}
                    />
                  </div>
                  <div className="form-field">
                    <label htmlFor="gender">Gender</label>
                    <select
                      id="gender"
                      value={this.state.gender}
                      onChange={(e) => this.setState({ gender: e.target.value })}
                    >
                      <option value="">Select gender</option>
                      <option value={1}>Male</option>
                      <option value={2}>Female</option>
                    </select>
                  </div>
                  <div className="form-field">
                    <label htmlFor="grade">School grade</label>
                    <select
                      id="grade"
                      value={this.state.schoolStagesId}
                      onChange={(e) => this.setState({ schoolStagesId: e.target.value })}
                    >
                      <option value="">Select grade</option>
                      {schoolStages.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-field">
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      id="password"
                      value={this.state.password}
                      onChange={(e) => this.setState({ password: e.target.value })}
                    />
                  </div>
                </div>
                <button className={`nd-btn-dark auth-submit ${submitting ? "loading" : ""}`} type="submit" disabled={submitting}>
                  {buttonText}
                </button>
                {msg && <div className={`auth-msg ${msg.type}`}>{msg.text}</div>}
                <p className="auth-switch">
                  Already have an account? <Link to="/sign-in">Sign in</Link>
                </p>
              </form>
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default SignUp;
